import {Directive, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {LocalStoreService} from '../services';

@Directive({
    selector: '[customPageSize]'
})
export class CustomPageSizeDirective implements OnInit {
    // @Output() setPageSize: EventEmitter<any> = new EventEmitter<any>();

    @HostListener('page', ['$event']) onChangePage(event) {
        let pageSize = '';
        if (event.pageSize) pageSize = String(event.pageSize);
        this.localStoreService.setStorageValConfig('pageSize', pageSize);
    }
    constructor(private localStoreService: LocalStoreService) {
    }

    ngOnInit(): void {
        // const pageSize = parseInt(this.localStoreService.getStorageValConfig('pageSize')) || 10;
        // this.setPageSize.emit(pageSize);
    }
}
